module.exports = __webpack_public_path__ + "static/img/cp_1.ad1af74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp_1.png
// module id = BQAE
// module chunks = 0